export const API_URL = window.API_URL;
export const IMAGES_URL = window.IMAGES_URL;
